"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TagsFormField", {
  enumerable: true,
  get: function get() {
    return _TagsFormField["default"];
  }
});
var _TagsFormField = _interopRequireDefault(require("./TagsFormField"));